// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client'
import { client } from './client.gen'
import type {
  BerechnungData,
  BerechnungResponses,
  CantonCreateData,
  CantonCreateResponses,
  CantonDestroyData,
  CantonDestroyResponses,
  CantonListData,
  CantonListResponses,
  CantonPartialUpdateData,
  CantonPartialUpdateResponses,
  CantonRetrieveData,
  CantonRetrieveResponses,
  CantonUpdateData,
  CantonUpdateResponses,
  CategoryCreateData,
  CategoryCreateResponses,
  CategoryDestroyData,
  CategoryDestroyResponses,
  CategoryListData,
  CategoryListResponses,
  CategoryPartialUpdateData,
  CategoryPartialUpdateResponses,
  CategoryRetrieveData,
  CategoryRetrieveResponses,
  CategoryUpdateData,
  CategoryUpdateResponses,
  EducationCreateData,
  EducationCreateResponses,
  EducationDestroyData,
  EducationDestroyResponses,
  EducationListData,
  EducationListResponses,
  EducationPartialUpdateData,
  EducationPartialUpdateResponses,
  EducationRetrieveData,
  EducationRetrieveResponses,
  EducationUpdateData,
  EducationUpdateResponses,
  EntwicklungData,
  EntwicklungResponses,
  FaqCreateData,
  FaqCreateResponses,
  FaqDestroyData,
  FaqDestroyResponses,
  FaqListData,
  FaqListResponses,
  FaqPartialUpdateData,
  FaqPartialUpdateResponses,
  FaqRetrieveData,
  FaqRetrieveResponses,
  FaqUpdateData,
  FaqUpdateResponses,
  GavindustryCreateData,
  GavindustryCreateResponses,
  GavindustryDestroyData,
  GavindustryDestroyResponses,
  GavindustryListData,
  GavindustryListResponses,
  GavindustryPartialUpdateData,
  GavindustryPartialUpdateResponses,
  GavindustryRetrieveData,
  GavindustryRetrieveResponses,
  GavindustryUpdateData,
  GavindustryUpdateResponses,
  IndustryCheckRetrieveData,
  IndustryCheckRetrieveResponses,
  IndustryCreateData,
  IndustryCreateResponses,
  IndustryDestroyData,
  IndustryDestroyResponses,
  IndustryJobsListData,
  IndustryJobsListResponses,
  IndustryListData,
  IndustryListResponses,
  IndustryPartialUpdateData,
  IndustryPartialUpdateResponses,
  IndustryRetrieveData,
  IndustryRetrieveResponses,
  IndustryUpdateData,
  IndustryUpdateResponses,
  JobCreateData,
  JobCreateResponses,
  JobDestroyData,
  JobDestroyResponses,
  JobListData,
  JobListResponses,
  JobPartialUpdateData,
  JobPartialUpdateResponses,
  JobRetrieveData,
  JobRetrieveResponses,
  JobsiteCreateData,
  JobsiteCreateResponses,
  JobsiteDestroyData,
  JobsiteDestroyResponses,
  JobsiteListData,
  JobsiteListResponses,
  JobsitePartialUpdateData,
  JobsitePartialUpdateResponses,
  JobsiteRetrieveData,
  JobsiteRetrieveResponses,
  JobsiteUpdateData,
  JobsiteUpdateResponses,
  JobUpdateData,
  JobUpdateResponses,
  LohnletterCreateData,
  LohnletterCreateResponses,
  LohnletterDestroyData,
  LohnletterDestroyResponses,
  LohnletterListData,
  LohnletterListResponses,
  LohnletterPartialUpdateData,
  LohnletterPartialUpdateResponses,
  LohnletterRetrieveData,
  LohnletterRetrieveResponses,
  LohnletterUpdateData,
  LohnletterUpdateResponses,
  MunicipalityCreateData,
  MunicipalityCreateResponses,
  MunicipalityDestroyData,
  MunicipalityDestroyResponses,
  MunicipalityListData,
  MunicipalityListResponses,
  MunicipalityPartialUpdateData,
  MunicipalityPartialUpdateResponses,
  MunicipalityRetrieveData,
  MunicipalityRetrieveResponses,
  MunicipalityUpdateData,
  MunicipalityUpdateResponses,
  OccupationalgroupCreateData,
  OccupationalgroupCreateResponses,
  OccupationalgroupDestroyData,
  OccupationalgroupDestroyResponses,
  OccupationalgroupListData,
  OccupationalgroupListResponses,
  OccupationalgroupPartialUpdateData,
  OccupationalgroupPartialUpdateResponses,
  OccupationalgroupRetrieveData,
  OccupationalgroupRetrieveResponses,
  OccupationalgroupUpdateData,
  OccupationalgroupUpdateResponses,
  OccupationCreateData,
  OccupationCreateResponses,
  OccupationDestroyData,
  OccupationDestroyResponses,
  OccupationListData,
  OccupationListResponses,
  OccupationPartialUpdateData,
  OccupationPartialUpdateResponses,
  OccupationRetrieveData,
  OccupationRetrieveResponses,
  OccupationUpdateData,
  OccupationUpdateResponses,
  PageCreateData,
  PageCreateResponses,
  PageDestroyData,
  PageDestroyResponses,
  PageListData,
  PageListResponses,
  PagePartialUpdateData,
  PagePartialUpdateResponses,
  PageRetrieveData,
  PageRetrieveResponses,
  PageUpdateData,
  PageUpdateResponses,
  PositionCreateData,
  PositionCreateResponses,
  PositionDestroyData,
  PositionDestroyResponses,
  PositionListData,
  PositionListResponses,
  PositionPartialUpdateData,
  PositionPartialUpdateResponses,
  PositionRetrieveData,
  PositionRetrieveResponses,
  PositionUpdateData,
  PositionUpdateResponses,
  RegionCreateData,
  RegionCreateResponses,
  RegionDestroyData,
  RegionDestroyResponses,
  RegionListData,
  RegionListResponses,
  RegionPartialUpdateData,
  RegionPartialUpdateResponses,
  RegionRetrieveData,
  RegionRetrieveResponses,
  RegionUpdateData,
  RegionUpdateResponses,
  SchemaRetrieveData,
  SchemaRetrieveResponses,
  TeaserCreateData,
  TeaserCreateResponses,
  TeaserDestroyData,
  TeaserDestroyResponses,
  TeaserListData,
  TeaserListResponses,
  TeaserPartialUpdateData,
  TeaserPartialUpdateResponses,
  TeaserRetrieveData,
  TeaserRetrieveResponses,
  TeaserUpdateData,
  TeaserUpdateResponses
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * API endpoint that allows cantons to be viewed or edited.
 */
export const cantonList = <ThrowOnError extends boolean = false>(
  options?: Options<CantonListData, ThrowOnError>
) =>
  (options?.client ?? client).get<CantonListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/canton/',
    ...options
  })

/**
 * API endpoint that allows cantons to be viewed or edited.
 */
export const cantonCreate = <ThrowOnError extends boolean = false>(
  options: Options<CantonCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<CantonCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/canton/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows cantons to be viewed or edited.
 */
export const cantonDestroy = <ThrowOnError extends boolean = false>(
  options: Options<CantonDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<CantonDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/canton/{id}/',
    ...options
  })

/**
 * API endpoint that allows cantons to be viewed or edited.
 */
export const cantonRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<CantonRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<CantonRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/canton/{id}/',
    ...options
  })

/**
 * API endpoint that allows cantons to be viewed or edited.
 */
export const cantonPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CantonPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<CantonPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/canton/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows cantons to be viewed or edited.
 */
export const cantonUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CantonUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<CantonUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/canton/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const categoryList = <ThrowOnError extends boolean = false>(
  options: Options<CategoryListData, ThrowOnError>
) =>
  (options.client ?? client).get<CategoryListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/category/',
    ...options
  })

export const categoryCreate = <ThrowOnError extends boolean = false>(
  options: Options<CategoryCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<CategoryCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/category/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const categoryDestroy = <ThrowOnError extends boolean = false>(
  options: Options<CategoryDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<CategoryDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/category/{slug}/',
    ...options
  })

export const categoryRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<CategoryRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<CategoryRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/category/{slug}/',
    ...options
  })

export const categoryPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CategoryPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<CategoryPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/category/{slug}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const categoryUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CategoryUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<CategoryUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/category/{slug}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows educations to be viewed or edited.
 */
export const educationList = <ThrowOnError extends boolean = false>(
  options: Options<EducationListData, ThrowOnError>
) =>
  (options.client ?? client).get<EducationListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/education/',
    ...options
  })

/**
 * API endpoint that allows educations to be viewed or edited.
 */
export const educationCreate = <ThrowOnError extends boolean = false>(
  options: Options<EducationCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<EducationCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/education/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows educations to be viewed or edited.
 */
export const educationDestroy = <ThrowOnError extends boolean = false>(
  options: Options<EducationDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<EducationDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/education/{id}/',
    ...options
  })

/**
 * API endpoint that allows educations to be viewed or edited.
 */
export const educationRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<EducationRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<EducationRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/education/{id}/',
    ...options
  })

/**
 * API endpoint that allows educations to be viewed or edited.
 */
export const educationPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<EducationPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<EducationPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/education/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows educations to be viewed or edited.
 */
export const educationUpdate = <ThrowOnError extends boolean = false>(
  options: Options<EducationUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<EducationUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/education/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const faqList = <ThrowOnError extends boolean = false>(
  options: Options<FaqListData, ThrowOnError>
) =>
  (options.client ?? client).get<FaqListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/faq/',
    ...options
  })

export const faqCreate = <ThrowOnError extends boolean = false>(
  options: Options<FaqCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FaqCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/faq/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const faqDestroy = <ThrowOnError extends boolean = false>(
  options: Options<FaqDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<FaqDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/faq/{id}/',
    ...options
  })

export const faqRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FaqRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FaqRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/faq/{id}/',
    ...options
  })

export const faqPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FaqPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<FaqPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/faq/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const faqUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FaqUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<FaqUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/faq/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows gav industries to be viewed or edited.
 */
export const gavindustryList = <ThrowOnError extends boolean = false>(
  options?: Options<GavindustryListData, ThrowOnError>
) =>
  (options?.client ?? client).get<GavindustryListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/gavindustry/',
    ...options
  })

/**
 * API endpoint that allows gav industries to be viewed or edited.
 */
export const gavindustryCreate = <ThrowOnError extends boolean = false>(
  options: Options<GavindustryCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<GavindustryCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/gavindustry/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows gav industries to be viewed or edited.
 */
export const gavindustryDestroy = <ThrowOnError extends boolean = false>(
  options: Options<GavindustryDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<GavindustryDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/gavindustry/{id}/',
    ...options
  })

/**
 * API endpoint that allows gav industries to be viewed or edited.
 */
export const gavindustryRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<GavindustryRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<GavindustryRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/gavindustry/{id}/',
    ...options
  })

/**
 * API endpoint that allows gav industries to be viewed or edited.
 */
export const gavindustryPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<GavindustryPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<GavindustryPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/gavindustry/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows gav industries to be viewed or edited.
 */
export const gavindustryUpdate = <ThrowOnError extends boolean = false>(
  options: Options<GavindustryUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<GavindustryUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/gavindustry/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryList = <ThrowOnError extends boolean = false>(
  options: Options<IndustryListData, ThrowOnError>
) =>
  (options.client ?? client).get<IndustryListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/industry/',
    ...options
  })

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryCreate = <ThrowOnError extends boolean = false>(
  options: Options<IndustryCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<IndustryCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/industry/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryDestroy = <ThrowOnError extends boolean = false>(
  options: Options<IndustryDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<IndustryDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/industry/{id}/',
    ...options
  })

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<IndustryRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<IndustryRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/industry/{id}/',
    ...options
  })

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<IndustryPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<IndustryPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/industry/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryUpdate = <ThrowOnError extends boolean = false>(
  options: Options<IndustryUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<IndustryUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/industry/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryCheckRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<IndustryCheckRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<IndustryCheckRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/industry/{id}/check/',
    ...options
  })

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryJobsList = <ThrowOnError extends boolean = false>(
  options?: Options<IndustryJobsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<IndustryJobsListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/industry/jobs/',
    ...options
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const jobList = <ThrowOnError extends boolean = false>(
  options?: Options<JobListData, ThrowOnError>
) =>
  (options?.client ?? client).get<JobListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/job/',
    ...options
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const jobCreate = <ThrowOnError extends boolean = false>(
  options: Options<JobCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<JobCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/job/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const jobDestroy = <ThrowOnError extends boolean = false>(
  options: Options<JobDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<JobDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/job/{id}/',
    ...options
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const jobRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<JobRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<JobRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/job/{id}/',
    ...options
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const jobPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<JobPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<JobPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/job/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const jobUpdate = <ThrowOnError extends boolean = false>(
  options: Options<JobUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<JobUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/job/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const jobsiteList = <ThrowOnError extends boolean = false>(
  options: Options<JobsiteListData, ThrowOnError>
) =>
  (options.client ?? client).get<JobsiteListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/jobsite/',
    ...options
  })

export const jobsiteCreate = <ThrowOnError extends boolean = false>(
  options: Options<JobsiteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<JobsiteCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/jobsite/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const jobsiteDestroy = <ThrowOnError extends boolean = false>(
  options: Options<JobsiteDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<JobsiteDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/jobsite/{slug}/',
    ...options
  })

export const jobsiteRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<JobsiteRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<JobsiteRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/jobsite/{slug}/',
    ...options
  })

export const jobsitePartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<JobsitePartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<JobsitePartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/jobsite/{slug}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const jobsiteUpdate = <ThrowOnError extends boolean = false>(
  options: Options<JobsiteUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<JobsiteUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/jobsite/{slug}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const lohnletterList = <ThrowOnError extends boolean = false>(
  options: Options<LohnletterListData, ThrowOnError>
) =>
  (options.client ?? client).get<LohnletterListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/lohnletter/',
    ...options
  })

export const lohnletterCreate = <ThrowOnError extends boolean = false>(
  options: Options<LohnletterCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<LohnletterCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/lohnletter/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const lohnletterDestroy = <ThrowOnError extends boolean = false>(
  options: Options<LohnletterDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<LohnletterDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/lohnletter/{slug}/',
    ...options
  })

export const lohnletterRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<LohnletterRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<LohnletterRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/lohnletter/{slug}/',
    ...options
  })

export const lohnletterPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LohnletterPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<LohnletterPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/lohnletter/{slug}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const lohnletterUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LohnletterUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<LohnletterUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/lohnletter/{slug}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows municipalities to be viewed or edited.
 */
export const municipalityList = <ThrowOnError extends boolean = false>(
  options?: Options<MunicipalityListData, ThrowOnError>
) =>
  (options?.client ?? client).get<MunicipalityListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/municipality/',
    ...options
  })

/**
 * API endpoint that allows municipalities to be viewed or edited.
 */
export const municipalityCreate = <ThrowOnError extends boolean = false>(
  options: Options<MunicipalityCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<MunicipalityCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/municipality/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows municipalities to be viewed or edited.
 */
export const municipalityDestroy = <ThrowOnError extends boolean = false>(
  options: Options<MunicipalityDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<MunicipalityDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/municipality/{id}/',
    ...options
  })

/**
 * API endpoint that allows municipalities to be viewed or edited.
 */
export const municipalityRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<MunicipalityRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<MunicipalityRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/municipality/{id}/',
    ...options
  })

/**
 * API endpoint that allows municipalities to be viewed or edited.
 */
export const municipalityPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<MunicipalityPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<MunicipalityPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/municipality/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows municipalities to be viewed or edited.
 */
export const municipalityUpdate = <ThrowOnError extends boolean = false>(
  options: Options<MunicipalityUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<MunicipalityUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/municipality/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationList = <ThrowOnError extends boolean = false>(
  options?: Options<OccupationListData, ThrowOnError>
) =>
  (options?.client ?? client).get<OccupationListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/occupation/',
    ...options
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationCreate = <ThrowOnError extends boolean = false>(
  options: Options<OccupationCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<OccupationCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/occupation/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationDestroy = <ThrowOnError extends boolean = false>(
  options: Options<OccupationDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<OccupationDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/occupation/{id}/',
    ...options
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<OccupationRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<OccupationRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/occupation/{id}/',
    ...options
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<OccupationPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<OccupationPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/occupation/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationUpdate = <ThrowOnError extends boolean = false>(
  options: Options<OccupationUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<OccupationUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/occupation/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationalgroupList = <ThrowOnError extends boolean = false>(
  options?: Options<OccupationalgroupListData, ThrowOnError>
) =>
  (options?.client ?? client).get<OccupationalgroupListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/occupationalgroup/',
    ...options
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationalgroupCreate = <ThrowOnError extends boolean = false>(
  options: Options<OccupationalgroupCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<OccupationalgroupCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/occupationalgroup/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationalgroupDestroy = <ThrowOnError extends boolean = false>(
  options: Options<OccupationalgroupDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<OccupationalgroupDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/occupationalgroup/{id}/',
    ...options
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationalgroupRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<OccupationalgroupRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<OccupationalgroupRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/occupationalgroup/{id}/',
    ...options
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationalgroupPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<OccupationalgroupPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<OccupationalgroupPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/occupationalgroup/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationalgroupUpdate = <ThrowOnError extends boolean = false>(
  options: Options<OccupationalgroupUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<OccupationalgroupUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/occupationalgroup/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const pageList = <ThrowOnError extends boolean = false>(
  options: Options<PageListData, ThrowOnError>
) =>
  (options.client ?? client).get<PageListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/page/',
    ...options
  })

export const pageCreate = <ThrowOnError extends boolean = false>(
  options: Options<PageCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<PageCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/page/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const pageDestroy = <ThrowOnError extends boolean = false>(
  options: Options<PageDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<PageDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/page/{slug}/',
    ...options
  })

export const pageRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<PageRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<PageRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/page/{slug}/',
    ...options
  })

export const pagePartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PagePartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<PagePartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/page/{slug}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const pageUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PageUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<PageUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/page/{slug}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows positions to be viewed or edited.
 */
export const positionList = <ThrowOnError extends boolean = false>(
  options: Options<PositionListData, ThrowOnError>
) =>
  (options.client ?? client).get<PositionListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/position/',
    ...options
  })

/**
 * API endpoint that allows positions to be viewed or edited.
 */
export const positionCreate = <ThrowOnError extends boolean = false>(
  options: Options<PositionCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<PositionCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/position/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows positions to be viewed or edited.
 */
export const positionDestroy = <ThrowOnError extends boolean = false>(
  options: Options<PositionDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<PositionDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/position/{id}/',
    ...options
  })

/**
 * API endpoint that allows positions to be viewed or edited.
 */
export const positionRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<PositionRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<PositionRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/position/{id}/',
    ...options
  })

/**
 * API endpoint that allows positions to be viewed or edited.
 */
export const positionPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PositionPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<PositionPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/position/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows positions to be viewed or edited.
 */
export const positionUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PositionUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<PositionUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/position/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const berechnung = <ThrowOnError extends boolean = false>(
  options: Options<BerechnungData, ThrowOnError>
) =>
  (options.client ?? client).post<BerechnungResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/rechner/berechnung/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const entwicklung = <ThrowOnError extends boolean = false>(
  options: Options<EntwicklungData, ThrowOnError>
) =>
  (options.client ?? client).post<EntwicklungResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/rechner/entwicklung/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows grossregions to be viewed or edited.
 */
export const regionList = <ThrowOnError extends boolean = false>(
  options?: Options<RegionListData, ThrowOnError>
) =>
  (options?.client ?? client).get<RegionListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/region/',
    ...options
  })

/**
 * API endpoint that allows grossregions to be viewed or edited.
 */
export const regionCreate = <ThrowOnError extends boolean = false>(
  options: Options<RegionCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<RegionCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/region/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows grossregions to be viewed or edited.
 */
export const regionDestroy = <ThrowOnError extends boolean = false>(
  options: Options<RegionDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<RegionDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/region/{id}/',
    ...options
  })

/**
 * API endpoint that allows grossregions to be viewed or edited.
 */
export const regionRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<RegionRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<RegionRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/region/{id}/',
    ...options
  })

/**
 * API endpoint that allows grossregions to be viewed or edited.
 */
export const regionPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<RegionPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<RegionPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/region/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * API endpoint that allows grossregions to be viewed or edited.
 */
export const regionUpdate = <ThrowOnError extends boolean = false>(
  options: Options<RegionUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<RegionUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/region/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const schemaRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<SchemaRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<SchemaRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/schema/',
    ...options
  })

export const teaserList = <ThrowOnError extends boolean = false>(
  options: Options<TeaserListData, ThrowOnError>
) =>
  (options.client ?? client).get<TeaserListResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/teaser/',
    ...options
  })

export const teaserCreate = <ThrowOnError extends boolean = false>(
  options: Options<TeaserCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TeaserCreateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/teaser/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const teaserDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TeaserDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<TeaserDestroyResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/teaser/{id}/',
    ...options
  })

export const teaserRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TeaserRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<TeaserRetrieveResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/teaser/{id}/',
    ...options
  })

export const teaserPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TeaserPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<TeaserPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/teaser/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const teaserUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TeaserUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<TeaserUpdateResponses, unknown, ThrowOnError>({
    security: [
      { scheme: 'basic', type: 'http' },
      { name: 'Authorization', type: 'apiKey' }
    ],
    url: '/api/teaser/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })
